module.exports = __webpack_public_path__ + "static/media/pipe2_down.7ab5a22f.png";